module.exports = __webpack_public_path__ + "img/valley-clean-air-now@2x.16649b39.webp";